var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$i18n.locale == 'en')?_c('payment-in'):_c('payment-ru')}
var staticRenderFns = []

export { render, staticRenderFns }